var map = {
	"./flg1.svg": 518,
	"./flg10.svg": 519,
	"./flg2.svg": 520,
	"./flg3.svg": 521,
	"./flg4.svg": 522,
	"./flg5.svg": 523,
	"./flg6.svg": 524,
	"./flg7.svg": 525,
	"./flg8.svg": 526,
	"./flg9.svg": 527
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 537;


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/flag nonrecursive \.svg$
// module id = 537
// module chunks = 1